





















import { defineComponent } from '@nuxtjs/composition-api';

interface Props extends Blok {
  heading: string;
  subheading: string;
  extra: Blok[];
  callToAction: Blok[];
  headingMaxWidth: number;
  subheadingMaxWidth: number;
}

export default defineComponent({
  props: {
    blok: { type: Object as () => Props, required: true },
  },
  computed: {
    cssVars(): CSSVars {
      return {
        '--heading-max-width': this.blok.headingMaxWidth
          ? `${this.blok.headingMaxWidth}ch`
          : '100%',
        '--subheading-max-width': this.blok.subheadingMaxWidth
          ? `${this.blok.subheadingMaxWidth}ch`
          : '100%',
      };
    },
  },
});
